export function getEnvVar(env: string) {
  // typeof guard, not just optional chaining: with the webpack ProcessPlugin
  // shim gone (P6), a bare `process` reference in the browser is an undeclared
  // identifier and throws ReferenceError — `process?.` does not survive that.
  return typeof process !== 'undefined' ? process?.env?.[env] : undefined;
}

export const ENV_VARS = {
  app: getEnvVar('APP'),
} as const;
